import React, { useState, useEffect, useRef, useContext } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
   Box,
   Button,
   Card,
   Container,
   Grid,
   Typography,
   CardContent,
   Pagination
} from '@material-ui/core'
import Loader from '../components/utils/Loader'
import Download from '@material-ui/icons/Download'
import User from '@material-ui/icons/SupervisedUserCircle'
import Chevron from '@material-ui/icons/ChevronLeft'

// API
import { getPublicAPI, putPublicAPI } from '../api/index'
import { ToastContext } from '../contexts/Toast'
import logo from '../assets/images/logo.jpg'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import socket from '../components/Socket'

const Shopping = () => {
   let mounted = useRef(true)
   const navigate = useNavigate()
   const { setToasts } = useContext(ToastContext)

   const [loading, setLoading] = useState(true)
   const [loadingOrders, setLoadingOrders] = useState(true)
   const [shipped, setShipped] = useState(null)
   const [orders, setShopping] = useState([])
   const [shoppingNumber, setShoppingNumber] = useState(0)
   const [selectedProduct, setSelectedProduct] = useState(null)
   const [selectedOrder, setSelectedOrder] = useState(null)
   const [postalcompany, setPostalCompany] = useState('')
   const [docketnumber, setDocketNumber] = useState('')
   const [open, setOpen] = useState(false)

   const [selectedSpan, setSelectedSpan] = useState('last-3-months')
   const [selectedSpanName, setSelectedSpanName] = useState('Last 3 months')
   const [paneFlag, setPaneFlag] = useState(false)
   const [prevSelectedSpan, setPrevSelectedSpan] = useState('last-3-months')
   const [pageNumber, setPageNumber] = useState(1)

   const handleClickOpen = (product, order) => {
      setPostalCompany('')
      setDocketNumber('')
      setSelectedProduct(product)
      setSelectedOrder(order)
      setOpen(true)
   }

   const handleClose = () => setOpen(false)

   useEffect(() => {
      if (!localStorage.auth_token) navigate('/login')

      return () => (mounted.current = false)
   }, [navigate])

   useEffect(() => {
      const prepareShopping = async () => {
         mounted.current && setLoadingOrders(true)
         let data = {
            user: localStorage.user_email,
            type: localStorage.user_type,
            offset: prevSelectedSpan === selectedSpan ? pageNumber - 1 : 0,
            span: selectedSpan
         }

         let ordersData = await getPublicAPI('/get-orders', data)
         if (ordersData?.success) {
            ordersData.data.sort(
               (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime()
            )

            mounted.current && setShopping(ordersData.data)
            mounted.current && setShoppingNumber(ordersData.number)
            mounted.current && setLoadingOrders(false)
         }

         setLoading(false)
      }

      prepareShopping()
   }, [setToasts, pageNumber, selectedSpan, prevSelectedSpan])

   const shipProduct = async (order, product) => {
      try {
         if (postalcompany === '') {
            setToasts({
               type: 'error',
               messages: [{ msg: `Enter postal company` }]
            })
         } else if (docketnumber === '') {
            setToasts({
               type: 'error',
               messages: [{ msg: `Enter tracking number` }]
            })
         } else {
            setOpen(false)

            const obj = {}
            obj.user = order.user
            obj.oNum = order.oNum
            obj.product = product.pId

            socket.emit('userNotify', JSON.stringify(obj))
            setShipped(product.pId + order.oNum)

            let params = {
               user: order.user,
               order: order.oNum,
               product: product.pId,
               postalcompany,
               docketnumber
               // single: true
            }

            let shipped = await putPublicAPI('/ship-product', params)
            if (shipped?.success) {
               setToasts({
                  type: 'success',
                  messages: [
                     {
                        // msg: `Product ${product.pId} of User ${order.user} from Order # ${order.oNum} has been shipped`
                        msg: `Product marked as shipped`
                     }
                  ]
               })

               shipped.data.sort(
                  (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime()
               )

               mounted.current && setShopping(shipped.data)
            } else
               setToasts({
                  type: 'error',
                  messages: shipped?.errors
               })
         }
      } catch (err) {
         setToasts({
            type: 'error',
            messages: [{ msg: err.message }]
         })
      } finally {
         setShipped(null)
         setSelectedProduct(null)
         setSelectedOrder(null)
         // navigate('/app/order-detail/' + order.oNum)
      }
   }

   const downloadOrder = async order => {
      // let signedUrl = await getPublicAPI('/generate-signed-url', { url: order.eFile })

      // if (signedUrl?.success) {
      let downloadLink = document.createElement('a')
      downloadLink.href = order.eFile
      downloadLink.download = order.oNum + '.xlsx'
      downloadLink.click()
      // }
   }

   socket.on('notifyAdmin', msg => {
      const prepareShopping = async () => {
         let data = { user: localStorage.user_email, type: localStorage.user_type }
         let orders = await getPublicAPI('/get-orders', data)

         if (orders?.success) {
            let data = JSON.parse(msg)
            let user = data.user
            localStorage.user_type !== 'customer' &&
               setToasts({
                  type: 'success',
                  messages: [
                     {
                        msg: `New Order from ${user}`
                     }
                  ]
               })

            orders.data.sort(
               (a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime()
            )

            mounted.current && setShopping(orders.data)
         }
      }

      prepareShopping()
   })

   const years = [2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]
   const months = [
      { num: 0, name: 'January' },
      { num: 1, name: 'February' },
      { num: 2, name: 'March' },
      { num: 3, name: 'April' },
      { num: 4, name: 'May' },
      { num: 5, name: 'June' },
      { num: 6, name: 'July' },
      { num: 7, name: 'August' },
      { num: 8, name: 'September' },
      { num: 9, name: 'October' },
      { num: 10, name: 'November' },
      { num: 11, name: 'December' }
   ]

   return (
      <>
         <Helmet>
            <title>
               {loading
                  ? 'Loading...'
                  : `${
                       localStorage.user_type !== 'customer' ? `Sales` : `Purchases`
                    } | The HosePod`}
            </title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               ) : (
                  <>
                     <Grid sx={{ p: 5, flexDirection: 'column' }} container spacing={3}>
                        <Box className='sale-head-container'>
                           <Typography color='textPrimary' gutterBottom className='part-number'>
                              Total {localStorage.user_type !== 'customer' ? 'Sales' : 'Purchases'}
                           </Typography>
                           <Box className='time-span-container'>
                              <Button
                                 onClick={() => setPaneFlag(!paneFlag)}
                                 className='time-span main'
                              >
                                 {selectedSpanName}
                                 {paneFlag ? (
                                    <Chevron
                                       sx={{ transform: 'rotate(90deg)' }}
                                       color='textPrimary'
                                       fontSize='large'
                                    />
                                 ) : (
                                    <Chevron
                                       sx={{ transform: 'rotate(-90deg)' }}
                                       color='textPrimary'
                                       fontSize='large'
                                    />
                                 )}
                              </Button>
                              {paneFlag && (
                                 <Box className='time-span-dropdown'>
                                    <Button
                                       onClick={() => {
                                          setPrevSelectedSpan(selectedSpan)
                                          setSelectedSpan('last-3-months')
                                          setSelectedSpanName('Last 3 months')
                                          setPaneFlag(false)
                                       }}
                                       className={
                                          selectedSpan === 'last-3-months'
                                             ? 'time-span selected'
                                             : 'time-span'
                                       }
                                       // variant='contained'
                                       // disabled={selectedSpan === 'last-3-months'}
                                    >
                                       Last 3 months
                                    </Button>
                                    {months.reverse().map(month =>
                                       month.num <= new Date().getMonth() ? (
                                          <Button
                                             onClick={() => {
                                                setPrevSelectedSpan(selectedSpan)
                                                setSelectedSpan(`${month.num}`)
                                                setSelectedSpanName(`${month.name}`)
                                                setPaneFlag(false)
                                             }}
                                             className={
                                                selectedSpan === `${month.num}`
                                                   ? 'time-span selected'
                                                   : 'time-span'
                                             }
                                             // disabled={selectedSpan === `${month.num}`}
                                             // variant='contained'
                                             key={month.num}
                                          >
                                             {month.name}
                                          </Button>
                                       ) : (
                                          <Box key={month.num} />
                                       )
                                    )}
                                    {years.reverse().map(year =>
                                       year <= new Date().getFullYear() ? (
                                          <Button
                                             onClick={() => {
                                                setPrevSelectedSpan(selectedSpan)
                                                setSelectedSpan(`${year}`)
                                                setSelectedSpanName(`${year}`)
                                                setPaneFlag(false)
                                             }}
                                             className={
                                                selectedSpan === `${year}`
                                                   ? 'time-span selected'
                                                   : 'time-span'
                                             }
                                             // disabled={selectedSpan === `${year}`}
                                             // variant='contained'
                                             key={year}
                                          >
                                             {year}
                                          </Button>
                                       ) : (
                                          <Box key={year} />
                                       )
                                    )}
                                 </Box>
                              )}
                           </Box>
                        </Box>
                        <Box>
                           {orders.length > 0 && (
                              <Box sx={{ pb: 2, pt: 2 }}>
                                 <Pagination
                                    color='primary'
                                    count={Math.ceil(shoppingNumber / 10)}
                                    onChange={(e, n) => setPageNumber(n)}
                                    size='small'
                                    page={pageNumber}
                                 />
                              </Box>
                           )}
                           <Card sx={{ backgroundColor: '#fff', boxShadow: 0 }}>
                              {loadingOrders ? (
                                 <Loader />
                              ) : orders.length > 0 ? (
                                 <Box className='whole-orders' sx={{ backgroundColor: '#fff' }}>
                                    {orders?.map((order, index) => {
                                       return (
                                          <Box key={index} className='order-head'>
                                             <Box className='order-inner-head'>
                                                <Box className='order-head-info'>
                                                   <Box>
                                                      <Typography sx={{ fontWeight: '600' }}>
                                                         ORDER PLACED
                                                      </Typography>
                                                      <Typography>
                                                         {moment
                                                            .utc(order.datetime)
                                                            .local()
                                                            .format('hh:mm A, DD MMM YYYY')}
                                                      </Typography>
                                                   </Box>
                                                   <Box>
                                                      <Typography sx={{ fontWeight: '600' }}>
                                                         TOTAL
                                                      </Typography>
                                                      <Typography>{`$${order.totalAmount?.toFixed(
                                                         2
                                                      )}`}</Typography>
                                                   </Box>
                                                </Box>
                                                <Box className='download-view' sx={{ mb: 1 }}>
                                                   <Box>
                                                      <CardContent
                                                         onClick={() =>
                                                            navigate(
                                                               '/app/order-detail/' + order.oNum
                                                            )
                                                         }
                                                         sx={{ pb: 0 }}
                                                      >
                                                         <Typography
                                                            sx={{ fontWeight: '600' }}
                                                         >{`ORDER # ${order.oNum}`}</Typography>
                                                         <Typography
                                                            sx={{ fontWeight: '600' }}
                                                         >{`PURCHASE # ${order.purNum}`}</Typography>
                                                         {localStorage.user_type !== 'customer' && (
                                                            <Typography
                                                               sx={{ fontWeight: '600' }}
                                                            >{`ORDERED BY: ${order.user}`}</Typography>
                                                         )}
                                                      </CardContent>
                                                   </Box>
                                                   <Box
                                                      sx={{
                                                         float: 'right',
                                                         display: 'flex',
                                                         flexDirection: 'column'
                                                      }}
                                                   >
                                                      {localStorage.user_type !== 'customer' && (
                                                         <Button
                                                            onClick={() =>
                                                               navigate(
                                                                  '/app/customers/profile/' +
                                                                     order.user
                                                               )
                                                            }
                                                         >
                                                            <User
                                                               color='textPrimary'
                                                               fontSize='large'
                                                            />
                                                         </Button>
                                                      )}
                                                      {order.eFile && (
                                                         <Button
                                                            onClick={() => downloadOrder(order)}
                                                         >
                                                            <Download
                                                               color='textPrimary'
                                                               fontSize='large'
                                                            />
                                                         </Button>
                                                      )}
                                                   </Box>
                                                </Box>
                                             </Box>
                                             <Box
                                                sx={{ p: 4, background: '#fff', borderRadius: 2 }}
                                             >
                                                {order.products?.map((product, index) => {
                                                   return (
                                                      <CardContent
                                                         onClick={() =>
                                                            navigate('/app/product/' + product.rhpn)
                                                         }
                                                         key={index}
                                                         className='order-products'
                                                      >
                                                         <Box sx={{ pl: 2 }}>
                                                            <img
                                                               className='order-product-images'
                                                               src={
                                                                  product.pictures.length > 0
                                                                     ? product.pictures[0]
                                                                     : logo
                                                               }
                                                               alt={product.rhpn}
                                                            />
                                                         </Box>
                                                         <Box sx={{ p: 3 }}>
                                                            <Typography
                                                               sx={{
                                                                  fontWeight: '600',
                                                                  color: 'grey'
                                                               }}
                                                            >
                                                               {product.rhpn + ' | ' + product.desc}
                                                            </Typography>
                                                            <Typography
                                                               sx={{
                                                                  fontWeight: '600',
                                                                  color: 'grey'
                                                               }}
                                                            >
                                                               {'Price: $'}
                                                               {product.type === 'hose'
                                                                  ? parseFloat(
                                                                       (
                                                                          parseFloat(
                                                                             product.amount
                                                                          ) /
                                                                          (parseFloat(
                                                                             product.qty.split(
                                                                                '-'
                                                                             )[0]
                                                                          ) +
                                                                             parseFloat(
                                                                                product.qty.split(
                                                                                   '-'
                                                                                )[1]
                                                                             ) /
                                                                                12)
                                                                       ).toFixed(2)
                                                                    )
                                                                  : (
                                                                       parseFloat(product.amount) /
                                                                       parseFloat(product.qty)
                                                                    ).toFixed(2)}
                                                            </Typography>
                                                            <Typography
                                                               sx={{
                                                                  fontWeight: '600',
                                                                  color: 'grey'
                                                               }}
                                                            >
                                                               {'Quantity: '}
                                                               {product.type === 'hose'
                                                                  ? `${product.qty.split('-')[0]} ${
                                                                       parseInt(
                                                                          product.qty.split('-')[0]
                                                                       ) === 1
                                                                          ? `feet`
                                                                          : `feets`
                                                                    } ${
                                                                       product.qty.split('-')[1]
                                                                    } ${
                                                                       parseInt(
                                                                          product.qty.split('-')[1]
                                                                       ) === 1
                                                                          ? `inch`
                                                                          : `inches`
                                                                    }`
                                                                  : product.qty}
                                                            </Typography>
                                                            <Typography
                                                               sx={{
                                                                  fontWeight: '600',
                                                                  color: 'grey'
                                                               }}
                                                            >
                                                               {'Amount: $' + product.amount}
                                                            </Typography>
                                                            {product.postalCompany &&
                                                               product.postalCompany.length > 0 && (
                                                                  <Typography
                                                                     sx={{
                                                                        fontWeight: '600',
                                                                        color: 'grey'
                                                                     }}
                                                                  >
                                                                     {'Carrier Name: ' +
                                                                        product.postalCompany.toUpperCase()}
                                                                  </Typography>
                                                               )}
                                                            {product.docketNumber &&
                                                               product.docketNumber.length > 0 && (
                                                                  <Typography
                                                                     sx={{
                                                                        fontWeight: '600',
                                                                        color: 'grey'
                                                                     }}
                                                                  >
                                                                     {'Tracking Number: ' +
                                                                        product.docketNumber}
                                                                  </Typography>
                                                               )}
                                                         </Box>
                                                         <Box
                                                            sx={{
                                                               display: 'flex',
                                                               justifyContent: 'space-between',
                                                               alignItems: 'center',
                                                               width: '100%'
                                                            }}
                                                         >
                                                            {product.status === 'processing' ? (
                                                               <Typography
                                                                  className='order-status'
                                                                  sx={{
                                                                     pl: 3,
                                                                     color: 'greenyellow'
                                                                  }}
                                                               >
                                                                  Processing
                                                               </Typography>
                                                            ) : (
                                                               <Typography
                                                                  className='order-status'
                                                                  sx={{
                                                                     pl: 3,
                                                                     color: '#d22f25'
                                                                  }}
                                                               >
                                                                  Shipped
                                                               </Typography>
                                                            )}
                                                            {localStorage.user_type !==
                                                               'customer' &&
                                                               product.status === 'processing' && (
                                                                  <Box sx={{ display: 'none' }}>
                                                                     <Button
                                                                        variant='contained'
                                                                        disabled={
                                                                           shipped ===
                                                                           product.pId + order.oNum
                                                                        }
                                                                        sx={{ fontWeight: '600' }}
                                                                        onClick={() =>
                                                                           handleClickOpen(
                                                                              product,
                                                                              order
                                                                           )
                                                                        }
                                                                     >
                                                                        Ship
                                                                     </Button>
                                                                     <Dialog
                                                                        open={open}
                                                                        onClose={handleClose}
                                                                        aria-labelledby='form-dialog-title'
                                                                     >
                                                                        <DialogTitle id='form-dialog-title'>
                                                                           Shipping Particulars
                                                                        </DialogTitle>
                                                                        <DialogContent>
                                                                           <DialogContentText>
                                                                              Enter shipping details
                                                                           </DialogContentText>
                                                                           <TextField
                                                                              autoFocus
                                                                              margin='dense'
                                                                              id='filled-error'
                                                                              label='Postal Company'
                                                                              fullWidth
                                                                              onChange={e => {
                                                                                 setPostalCompany(
                                                                                    e.target.value
                                                                                 )
                                                                              }}
                                                                           />
                                                                           <TextField
                                                                              autoFocus
                                                                              margin='dense'
                                                                              label='Tracking Number'
                                                                              fullWidth
                                                                              onChange={e => {
                                                                                 setDocketNumber(
                                                                                    e.target.value
                                                                                 )
                                                                              }}
                                                                           />
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                           <Button
                                                                              onClick={() =>
                                                                                 shipProduct(
                                                                                    selectedOrder,
                                                                                    selectedProduct
                                                                                 )
                                                                              }
                                                                              color='secondary'
                                                                           >
                                                                              Ship
                                                                           </Button>
                                                                        </DialogActions>
                                                                     </Dialog>
                                                                  </Box>
                                                               )}
                                                         </Box>
                                                      </CardContent>
                                                   )
                                                })}
                                             </Box>
                                          </Box>
                                       )
                                    })}
                                 </Box>
                              ) : (
                                 <Box sx={{ p: 5 }}>
                                    <Typography
                                       sx={{
                                          fontWeight: '600',
                                          fontSize: '24px',
                                          textAlign: 'center'
                                       }}
                                    >
                                       {localStorage.user_type !== 'customer'
                                          ? `No sales yet.`
                                          : `No purchases yet.`}
                                    </Typography>
                                 </Box>
                              )}
                           </Card>
                        </Box>
                     </Grid>
                  </>
               )}
            </Container>
         </Box>
      </>
   )
}

export default Shopping
